// /SalesOrderRecord/index.js
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ArrowLeftOutlined, PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import SalesOrderRecordFilters from "./components/SalesOrderRecordFilters";
import SalesOrderRecordTable from "./components/SalesOrderRecordTable";
import { fetchSalesOrderRecord } from "./SalesOrderRecordThunk";
import ReportDom from "../../../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";

const { Title } = Typography;

const SalesOrderRecord = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  useEffect(() => {
    dispatch(fetchSalesOrderRecord({})); // initial load
  }, [dispatch]);

  const { filters, list } = useSelector((state) => state.salesOrderRecord);

  const reportRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,    
    documentTitle: "Sales Order Report",
    removeAfterPrint: true, // cleanup after printing
  });

  return (
    <div className="p-4" style={{ overflowX: "hidden", width: "100%" }}>
      <App>        
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
            <Flex align="center">
              <Button
                type="text"
                icon={<ArrowLeftOutlined style={{ fontSize: 18 }} />}
                onClick={() => navigate(-1)}
                style={{ marginRight: 8, padding: 0, height: "auto", lineHeight: "1", color: "#000" }}
                data-testid="sales-order-record-back-button"
              />
              <Title level={4} style={{ margin: 0 }}>Sales Order Record</Title>
            </Flex>
          }
          extra={
            <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
              { !screens.xs && "Print" }
            </Button>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },  
            body: { padding: 0 },                                    
          }}
        />

        <SalesOrderRecordFilters messageApi={message} />
        <Card className="shadow-md rounded-xl">
          <SalesOrderRecordTable />
        </Card>
      </App>
      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
          <ReportDom
            ref={reportRef}
            title="Product Replace Report"
            mode="report-page"
            filters={filters}
            // columns={columns}
            // data={list}
            renderTable={() => (
            <SalesOrderRecordTable pagination={false} printMode={true}/>   /* ✅ reuse your actual table */
            )}
          />
      </div>
    </div>
  );
};

export default SalesOrderRecord;
